const VALID_ENVIRONMENTS = [
  'development',
  'ci',
  'review',
  'staging',
  'preprod',
  'production',
] as const;

export type Environment = (typeof VALID_ENVIRONMENTS)[number];

function validateEnvironment(env: string | undefined): Environment {
  if (!env) {
    throw new Error('REACT_APP_ENV is not defined');
  }

  if (!VALID_ENVIRONMENTS.includes(env as Environment)) {
    throw new Error(
      `Invalid REACT_APP_ENV: ${env}. Must be one of: ${VALID_ENVIRONMENTS.join(', ')}`
    );
  }
  return env as Environment;
}

const currentEnvironment = validateEnvironment(import.meta.env.REACT_APP_ENV);

export const app = { env: currentEnvironment };

export const isProdLike = currentEnvironment === 'preprod' || currentEnvironment === 'production';
